import { Inject, Pipe } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { DateFormatBase } from '@skylab-shared/scenes';

@Pipe({ name: 'sklFormatDate' })
export class DateFormatPipe {
    private handler: DateFormatBase;

    public constructor(
        @Inject(L10n) l10n: L10nBase
    ) {
        this.handler = new DateFormatBase(l10n);
    }

    public transform(value: Date | string | null | undefined, format?: string): string {
        return this.handler.transform(value, format);
    }
}
